import { ENDPOINTS } from 'shared/constants/ENDPOINTS';
import { useAxios } from 'shared/hooks/useAxios';
import {
  IMediaDeleteResponse,
  IMediaRequestPayload,
  IMediaResponse,
  IMediaTagsResponsePayload,
  IRetrieveMultipleMediaUrlResponsePayload,
} from 'shared/interfaces/IMedia';
import { authToken } from 'shared/utils/authToken';

const { GET, PATCH, DELETE } = useAxios();

export const mediaDao = () => {
  const { getAuthToken } = authToken();
  const getMediaList = async (payload?: IMediaRequestPayload) => {
    const response = await GET<IMediaResponse>({
      url: `${ENDPOINTS.MEDIA}`,
      params: payload,
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });
    return response.data;
  };

  const updateMedia = async (mediumId: string, formData: FormData, onProgress?: (current: number) => void) => {
    const response = await PATCH<IMediaResponse>({
      url: `${ENDPOINTS.MEDIA}/${mediumId}`,
      data: formData,
      onUploadProgress: (progressEvent) => {
        if (onProgress) {
          onProgress((progressEvent.loaded / progressEvent.total) * 100);
        }
      },
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });
    return response.data;
  };

  const deleteMedia = async (mediumIds: string[], onProgress?: (current: number) => void) => {
    const response = await DELETE<IMediaDeleteResponse>({
      url: `${ENDPOINTS.MEDIA}`,
      data: { medium_ids: [...mediumIds] },
      onUploadProgress: (progressEvent) => {
        if (onProgress) {
          onProgress((progressEvent.loaded / progressEvent.total) * 100);
        }
      },
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });
    return response?.data;
  };

  const retrieveSingleMediaUrl = async (id: string) => {
    const response = await GET({
      url: `${ENDPOINTS.MEDIA}/${id}`,
    });
    return response.data;
  };

  const retrieveMultipleMediaUrl = async (ids: string[]) => {
    const response = await GET<IRetrieveMultipleMediaUrlResponsePayload>({
      url: `${ENDPOINTS.MEDIA_URLS}`,
      params: {
        ids,
      },
    });
    return response.data;
  };

  const getMediaTags = async (searchString: string) => {
    const response = await GET<IMediaTagsResponsePayload>({
      url: `${ENDPOINTS.MEDIA_TAGS}?search=${searchString}`,
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });

    return response.data;
  };

  return {
    getMediaTags,
    deleteMedia,
    getMediaList,
    updateMedia,
    retrieveSingleMediaUrl,
    retrieveMultipleMediaUrl,
  };
};
